import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isValid, reset } from 'redux-form';
import ParkReceipt from './ParkReceipt';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
  values: getFormValues('ParkReceiptForm')(state),
  isValid: isValid('ParkReceiptForm')(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('ParkReceiptForm')
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ParkReceipt);
